import React, { useState } from 'react';
import { Table, Card, Tag, Button, Space, Badge, Row, Col, Statistic, Modal, Form, Input, message } from 'antd';
import { PlusOutlined, ApiOutlined, KeyOutlined, CopyOutlined } from '@ant-design/icons';

const apiKeys = [
  { key: '1', name: '深圳割草机科技-主Key', appKey: 'ak_live_abc123def456', client: '深圳割草机科技', calls: 12480, limit: 100000, status: 'active', created: '2025-01-15' },
  { key: '2', name: '广州CPE公司-Key', appKey: 'ak_live_ghi789jkl012', client: '广州CPE公司', calls: 8620, limit: 50000, status: 'active', created: '2025-03-20' },
  { key: '3', name: '跃创上游API', appKey: 'ak_upstream_mno345pqr', client: '跃创（上游）', calls: 45200, limit: 999999, status: 'active', created: '2024-12-01' },
  { key: '4', name: '测试Key', appKey: 'ak_test_stu678vwx', client: '内部测试', calls: 320, limit: 10000, status: 'inactive', created: '2026-01-10' },
];

const logs = [
  { key: '1', method: 'GET', path: '/api/v1/cards', client: '深圳割草机科技', status: 200, time: '12ms', ts: '14:23:11' },
  { key: '2', method: 'POST', path: '/api/v1/cards/activate', client: '广州CPE公司', status: 200, time: '86ms', ts: '14:22:48' },
  { key: '3', method: 'GET', path: '/api/v1/traffic/query', client: '深圳割草机科技', status: 200, time: '34ms', ts: '14:22:20' },
  { key: '4', method: 'POST', path: '/api/v1/cards/stop', client: '跃创上游', status: 400, time: '18ms', ts: '14:21:55' },
  { key: '5', method: 'GET', path: '/api/v1/esim/profiles', client: '内部测试', status: 200, time: '45ms', ts: '14:21:30' },
];

const ApiManage: React.FC = () => {
  const [createVisible, setCreateVisible] = useState(false);

  return (
    <div style={{ padding: 16 }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {[
          { title: 'API密钥数', value: 4 }, { title: '今日调用', value: 12480 },
          { title: '成功率', value: '98.6%', color: '#52c41a' }, { title: '平均响应', value: '42ms', color: '#1890ff' },
        ].map((item, i) => (
          <Col span={6} key={i}>
            <Card bordered={false} style={{ borderRadius: 8 }}>
              <Statistic title={item.title} value={item.value} valueStyle={{ color: item.color || '#1890ff', fontWeight: 700 }} />
            </Card>
          </Col>
        ))}
      </Row>

      <Card
        title={<span><KeyOutlined /> API密钥管理</span>}
        extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => setCreateVisible(true)}>创建密钥</Button>}
        bordered={false}
        style={{ borderRadius: 8, marginBottom: 16 }}
      >
        <Table
          dataSource={apiKeys}
          size="small"
          pagination={false}
          columns={[
            { title: '名称', dataIndex: 'name', key: 'name' },
            {
              title: 'AppKey', dataIndex: 'appKey', key: 'appKey', width: 230,
              render: v => (
                <Space>
                  <code style={{ fontSize: 12, background: '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>{v}</code>
                  <Button size="small" icon={<CopyOutlined />} onClick={() => { navigator.clipboard?.writeText(v); message.success('已复制'); }} />
                </Space>
              )
            },
            { title: '归属客户', dataIndex: 'client', key: 'client' },
            {
              title: '调用量', key: 'calls', width: 160,
              render: (_: any, r: any) => `${r.calls.toLocaleString()} / ${r.limit.toLocaleString()}`
            },
            {
              title: '状态', dataIndex: 'status', key: 'status', width: 90,
              render: v => <Badge status={v === 'active' ? 'success' : 'default'} text={v === 'active' ? '启用' : '禁用'} />
            },
            { title: '创建日期', dataIndex: 'created', key: 'created', width: 110 },
            {
              title: '操作', key: 'action', width: 130,
              render: () => <Space><Button size="small">查看</Button><Button size="small" danger>禁用</Button></Space>
            },
          ]}
        />
      </Card>

      <Card
        title={<span><ApiOutlined /> 调用日志（实时）</span>}
        bordered={false}
        style={{ borderRadius: 8 }}
      >
        <Table
          dataSource={logs}
          size="small"
          pagination={{ pageSize: 10 }}
          columns={[
            {
              title: '方法', dataIndex: 'method', key: 'method', width: 80,
              render: v => <Tag color={v === 'GET' ? 'green' : v === 'POST' ? 'blue' : 'orange'}>{v}</Tag>
            },
            { title: '接口路径', dataIndex: 'path', key: 'path' },
            { title: '调用方', dataIndex: 'client', key: 'client' },
            {
              title: '状态码', dataIndex: 'status', key: 'status', width: 90,
              render: v => <Tag color={v === 200 ? 'success' : 'error'}>{v}</Tag>
            },
            { title: '耗时', dataIndex: 'time', key: 'time', width: 80 },
            { title: '时间', dataIndex: 'ts', key: 'ts', width: 100 },
          ]}
        />
      </Card>

      <Modal
        title="创建API密钥"
        open={createVisible}
        onCancel={() => setCreateVisible(false)}
        onOk={() => { message.success('密钥创建成功！'); setCreateVisible(false); }}
        okText="创建"
      >
        <Form layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item label="密钥名称" required><Input placeholder="如：客户名称-用途" /></Form.Item>
          <Form.Item label="归属客户" required><Input placeholder="选择或输入客户名称" /></Form.Item>
          <Form.Item label="调用限额（次/天）"><Input type="number" defaultValue={10000} /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ApiManage;
